import { Inject, Injectable, PLATFORM_ID } from "@angular/core";
import { ApiService } from "@core/services/api.service";
import { ApiServiceHolder } from "@core/utils/api-service-holder";
import { Observable, of, throwError } from "rxjs";
import { catchError, tap } from 'rxjs/operators';
import { NotificationService } from "src/app/account/services/notification.service";
import { PlatformService } from "./platform-service.service";

@Injectable({
  providedIn: 'root'
})

export class MessageService {
  unreadMessagesCount: number = 0;
  userDataCount: {
    unreadMessages: number
    unreadNotifications: number
    unpaidItems: number
  } = {
    unreadMessages: 0,
    unreadNotifications: 0,
    unpaidItems: 0
  };

  timeDifferenceFromStart: number;
  _refreshTimer = null;
  _refreshTimerInterval = 30 * 1000; // 30 secondi di timer

  constructor(
    private _api: ApiService,
    @Inject(PLATFORM_ID) private _platformId: Object,
    private notificationService: NotificationService,
    private platformService: PlatformService

  ) { }

  getCountUnreadMessages(): Observable<{
    unreadMessages: number
    unreadNotifications: number
    unpaidItems: number
  }> {
    return this._api.request<{
      unreadMessages: number
      unreadNotifications: number
      unpaidItems: number
    }>(ApiServiceHolder.message.getCountUnreadMessages())
    .pipe(
      tap((count) => {
        this.userDataCount = count;
      })
    )
    .pipe(catchError((e) => {
      if(e.status === 401) {
        this.unreadMessagesCount = 0;
        this.clearRefreshTimer();
        return of({
          unreadMessages: 0,
          unreadNotifications: 0,
          unpaidItems: 0
        });
      }

      return throwError(e);
    }))
    ;
  }

  updateMessageRead(idMessageList: number[]) {
    return this._api.request(ApiServiceHolder.message.updateMessageRead(idMessageList));
  }

  startTimer() {
    this.platformService.runOnBrowser(() => {
      this.updateCountUnreadMessages();
      this._refreshTimer = setInterval(() => {
        this.updateCountUnreadMessages();
      }, this._refreshTimerInterval);
    });
  }

  clearRefreshTimer(): void {
    if (this._refreshTimer) {
      clearInterval(this._refreshTimer);
      this._refreshTimer = null;
    }
  }

  ngOnDestroy() {
    this.clearRefreshTimer();
  }

  public updateCountUnreadMessages() {
    this.getCountUnreadMessages().subscribe((count) => {
      this.unreadMessagesCount = count.unreadMessages;
      this.notificationService.unreadNotificationsCount = count.unreadNotifications;
    });
  }
}
